// extracted by mini-css-extract-plugin
module.exports = {"links":"links-module--links--3tgnt"};